import { gql } from '@apollo/client';

export const GET_USER_EMAIL = gql`
  query getUserEmail($hashedEmail: String!) {
    user(hashedEmail: $hashedEmail) {
      email
    }
  }
`;

export default {};
